import { Button, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons';
import { useStyles } from '../../../styles';
import { useTranslation } from 'react-i18next';
import { themeColors } from '@/theme/colors';
import { MailServerForm } from './components/serverForm';
import { TEMPLATE_MAIL_SERVER } from '@/services/api/emailServerApiArea/types';

interface ICreateMailServerProps {
  CustomerId: number;
  handleChange?: () => void;
}
export const CreateMailServer = ({ CustomerId, handleChange }: ICreateMailServerProps) => {
  const [opened, { open, close }] = useDisclosure(false);
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <Button
        className={classes.addButton}
        size="sm"
        variant="outline"
        rightSection={<IconPlus color={themeColors.brandGray[0]} />}
        onClick={() => open()}
      >
        <Text fw="600" fz="14">
          {t('servers.create')}
        </Text>
      </Button>
      {opened && (
        <MailServerForm
          CustomerId={CustomerId}
          mailServer={TEMPLATE_MAIL_SERVER.TEMPLATE_MAIL_SERVER_ENTITY}
          handleChange={handleChange}
          opened={opened}
          handleClose={close}
          isEditing={false}
        />
      )}
    </>
  );
};
